import React from 'react';

import { TableCell, TableHead, TableRow, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { ArrayUtils } from '../../../../utils/array.utils';
import { SALES_DETAILS_PAYMENTS } from '../../constants';

const sxTableHead: SxProps<Theme> = { '& th': { fontWeight: 'bold', textAlign: 'center' } };

const SalesDetailsListHead = React.memo(() => {
  const { t } = useTranslation();

  return (
    <TableHead className="sticky-header-row">
      <TableRow sx={sxTableHead}>
        <TableCell>{t(`general.school`)}</TableCell>
        <TableCell>{t(`general.school_year`)}</TableCell>
        <TableCell>{t(`sales.date`)}</TableCell>
        <TableCell>{t(`sales.number`)}</TableCell>
        <TableCell>{t(`general.week`)}</TableCell>
        <TableCell>{t(`general.month`)}</TableCell>
        <TableCell>{t(`sales.customer`)}</TableCell>
        <TableCell>{t(`general.email`)}</TableCell>
        <TableCell>{t(`sales_details.deliveryCountry`)}</TableCell>
        <TableCell>{t(`sales_details.partnership`)}</TableCell>
        <TableCell>{t(`general.student`)}</TableCell>
        <TableCell>{t(`general.type`)}</TableCell>
        <TableCell>{t(`general.student_status`)}</TableCell>
        <TableCell>{t(`general.school_level`)}</TableCell>
        <TableCell>{t(`general.registration_type`)}</TableCell>
        <TableCell>{t(`general.duration`)}</TableCell>
        <TableCell>{t(`sales.total`)}</TableCell>
        <TableCell>{t(`sales.coco`)}</TableCell>
        <TableCell>{t(`sales.dise`)}</TableCell>
        <TableCell>{t(`sales.certificate`)}</TableCell>
        <TableCell>{t(`sales.pre_inscription`)}</TableCell>
        <TableCell>{t(`sales.books`)}</TableCell>
        <TableCell>{t(`sales.fees`)}</TableCell>
        <TableCell>{t(`sales.delivery`)}</TableCell>
        <TableCell>{t(`sales.discounts`)}</TableCell>
        <TableCell>{t(`sales.verify`)}</TableCell>
        <TableCell>{t(`sales_details.payments`)}</TableCell>

        {ArrayUtils.makeRange(SALES_DETAILS_PAYMENTS).map((number) => (
          <TableCell key={`header_payment_${number}`}>
            {t(`sales_details.payment`, { number })}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
});

export default SalesDetailsListHead;
